<header class="emptyHeaderMain"></header>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="col-md-12">
        <h1>Sign up</h1>
      </div>
    </div>
    <div class="col-md-12">
      <form
        [formGroup]="signupForm"
        class="form row"
        name="form"
        novalidate
        (ngSubmit)="signupForm.markAllAsTouched()">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label class="form-label" for="firstName">First Name</label>

            <input
              id="firstName"
              type="text"
              name="firstName"
              class="form-control"
              formControlName="firstName"
              required />

            <div class="invalid-feedback">
              <p *ngIf="firstName.errors?.required">First name is required</p>
            </div>
            <p *ngIf="errors && errors['firstName']">
              {{ errors['firstName'].message }}
            </p>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-3">
            <label class="form-label" for="name">Last Name</label>

            <input
              id="name"
              type="text"
              name="name"
              class="form-control"
              formControlName="name"
              required />

            <div class="invalid-feedback">
              <p *ngIf="name.errors?.required">A name is required</p>
            </div>
            <p *ngIf="errors && errors['name']">
              {{ errors['name'].message }}
            </p>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-3">
            <label class="form-label" for="email">Email</label>

            <input
              id="email"
              type="email"
              name="email"
              class="form-control"
              formControlName="email"
              [readonly]="!!invite"
              required />

            <div class="invalid-feedback">
              <p *ngIf="email.errors?.email || email.errors?.required">
                Doesn't look like a valid email.
              </p>
            </div>
            <p *ngIf="errors && errors['email']">
              {{ errors['email'].message }}
            </p>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-3">
            <label class="form-label" for="password">Password</label>

            <input
              id="password"
              type="password"
              name="password"
              class="form-control"
              formControlName="password"
              minlength="8"
              required
              autocomplete="new-password" />

            <div class="invalid-feedback">
              <p
                *ngIf="password.errors?.minlength || password.errors?.required">
                Password must be at least 8 characters.
              </p>
            </div>
            <p *ngIf="errors && errors['password']">
              {{ errors['password'].message }}
            </p>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-3">
            <label class="form-label" for="confirmPassword">
              Confirm Password
            </label>
            <input
              id="confirmPassword"
              type="password"
              name="confirmPassword"
              class="form-control"
              formControlName="confirmPassword"
              minlength="8"
              required
              autocomplete="new-password" />

            <div class="invalid-feedback">
              <p
                *ngIf="
                  confirmPassword.errors?.minlength ||
                  confirmPassword.errors?.required
                ">
                Password must be at least 8 characters.
              </p>
              <p *ngIf="password.value !== confirmPassword.value">
                Passwords must match.
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-3">
            <label class="form-label" for="acceptedTerms">
              Terms & Conditions
            </label>
            <div class="checkbox">
              <label>
                <input
                  id="acceptedTerms"
                  name="terms"
                  type="checkbox"
                  value=""
                  formControlName="acceptedTerms"
                  required />
                I accept the
                <a href="https://www.wedavinci.com/terms" target="_blank">
                  Terms and Conditions
                </a>
                and confirm that I have read the
                <a
                  href="https://www.wedavinci.com/data-protection-policy"
                  target="_blank">
                  Privacy Policy
                </a>
                .
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <button
            [disabled]="pending || signupForm.invalid"
            class="btn btn-secondary btn-lg btn-register"
            (click)="submitSignup()">
            Sign up
          </button>
        </div>

        <div class="row">
          <div class="col-md-4 col-lg-3">
            <!--
            <oauth-buttons classes="btn-block"></oauth-buttons>
            -->
          </div>
        </div>
      </form>
    </div>
  </div>
  <hr />
</div>
